import { Membership } from "@app/shared/types";
import { createContext } from "react";

export const MemberContext = createContext({
    memberships: [] as Membership[],
});
